<mat-accordion>
  @for (item of state.bettingsMap | keyvalue; track item) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ item.value.name }}</mat-panel-title>
        @if (item.value.stats) {
          <mat-panel-description class="oo-stats">
            {{ item.value.stats }}
          </mat-panel-description>
        }
      </mat-expansion-panel-header>
      <mat-list>
        @for (userBetting of item.value.userBettings; track userBetting) {
          <mat-list-item class="oo-row">
            <mat-icon matListItemIcon>
              {{ userBetting.bettingResult ? (userBetting.bettingResult === 'correct' ? 'done' : 'clear') : 'error' }}
            </mat-icon>
            <div matListItemTitle>{{ state.usersMap.get(userBetting.userId)!.name }}</div>
            <oo-bet-result-renderer [bettingType]="item.value.type"
                                    [bettingValue]="$any(userBetting.betting)"
                                    [form]="state.form"
                                    [metadata]="state.metadata"
                                    matListItemLine>
            </oo-bet-result-renderer>
          </mat-list-item>
        }
      </mat-list>
    </mat-expansion-panel>
  }
</mat-accordion>
